import React, { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ctaHref, ctaIsExternal } from '../config/site';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  const href = ctaHref();
  const external = ctaIsExternal();
  useEffect(() => {
    const onScroll = () => {
      const hero = document.getElementById('hero-sentinel');
      const offer = document.getElementById('oferta');
      const heroBottom = hero ? hero.getBoundingClientRect().bottom : 600;
      const offerTop = offer ? offer.getBoundingClientRect().top : Number.POSITIVE_INFINITY;
      const offerBottom = offer ? offer.getBoundingClientRect().bottom : Number.NEGATIVE_INFINITY;
      const pastHero = heroBottom < -200;
      const insideOffer = offerTop < window.innerHeight * 0.9 && offerBottom > 0;
      setVisible(pastHero && !insideOffer);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-174" data-mp="2z4boj8kbm9qn">
      {visible}
    </AnimatePresence>;
}